/**
 * Manual Search window bus — opens the title lookup overlay
 * from anywhere (nav button, keyboard shortcut, empty states).
 */

export const MANUAL_SEARCH_EVENT = "swiftix:manual-search-open";

export interface ManualSearchRequest {
  /** Optional pre-filled query, e.g. from an empty state CTA. */
  query?: string;
}

export const openManualSearch = (query?: string) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ManualSearchRequest>(MANUAL_SEARCH_EVENT, { detail: { query } })
  );
};
